import React, { useEffect, useState } from 'react';
import ErrorText from '../../ErrorText';
import { FormFieldProps } from '../../FormTypes';
import FormField from '../../FormField';
import { OutlinedTextInput, Text } from 'library';

const oneOrMoreNonWhitespaceRegex = /[^\s]+/;

export default function JobDescriptionInput({
    description,
    subtitle,
    business = false,
}: {
    description: FormFieldProps<string>;
    subtitle?: string;
    business?: boolean;
}) {
    const { value, setValue, isValid, setValid } = description;
    const [showErrors, setShowErrors] = useState(false);

    useEffect(() => setValid(!!value && oneOrMoreNonWhitespaceRegex.test(value)), [value]);

    return (
        <FormField title={`Job ${business ? 'Responsibilities*' : 'Description*'}`}>
            <div style={{ height: 10 }} />
            {subtitle ? (
                <Text variant="h2" bold textStyle={{ marginBottom: 10 }}>
                    {subtitle}
                </Text>
            ) : null}
            <OutlinedTextInput
                fullWidth
                value={value}
                onChange={onValueChanged}
                multiline
                rows={business ? 2 : 3}
                InputLabelProps={{ shrink: true }}
                id="job-form-description-input"
            />
            {jobDescriptionHasError() && (
                <ErrorText>Please enter {business ? 'job responsibilities' : 'a job description'}</ErrorText>
            )}
        </FormField>
    );

    function onValueChanged(event: any) {
        setShowErrors(true);

        setValue(event.target.value);
    }

    function jobDescriptionHasError() {
        return showErrors && !isValid;
    }
}
